import { useEffect, useMemo, useRef } from 'react';

export function usePreserveDataDuringLoading<T>(data: T | undefined, isLoading: boolean): T | undefined {
  const previousDataReference = useRef<T | undefined>(undefined);

  useEffect(() => {
    if (!isLoading && data !== undefined) {
      previousDataReference.current = data;
    }
  }, [data, isLoading]);

  return useMemo(() => {
    return isLoading ? previousDataReference.current : data;
  }, [isLoading, data]);
}
